import { DocTop } from '@/components/shell/DocTop';
import { SoldCredite } from './SoldCredite';
import { Instanta } from './Instanta';
import { canSeeBilling } from '@/lib/permissions';
import { useMe } from '@/lib/useMe';

export function PanouPage() {
  const { data: me } = useMe();
  const billing = canSeeBilling(me);
  return (
    <>
      <DocTop />
      <div className="mt-8">
        <h1 className="text-[32px] font-[650] text-ink">Panou</h1>
        <div className="mt-1 border-b-2 border-ink pb-3" />
        <div className={`mt-8 grid gap-4 ${billing ? 'sm:grid-cols-2' : ''}`}>
          {billing && <SoldCredite />}
          <Instanta />
        </div>
      </div>
    </>
  );
}
